export class Json<K extends keyof any, V> {
  [k: number]: V;
  [k: string]: V;

  constructor(value?: Array<V> | any, keyProp?: string, valueFn?: any) {
    if (value && Array.isArray(value) && value.length > 0 && keyProp && typeof keyProp === 'string' && keyProp.length > 0) {
      for (const item of value) {
        const finalValue = valueFn ? valueFn(item) : item;
        if (this[item[keyProp]] !== undefined && this[item[keyProp]] !== null) {
          if (Array.isArray(this[item[keyProp]])) {
            if (Array.isArray(finalValue)) {
              // @ts-ignore
              this[item[keyProp]].push(finalValue[0]);
            } else {
              // @ts-ignore
              this[item[keyProp]].push(finalValue);
            }
          } else {
            // @ts-ignore
            this[item[keyProp]] = new Array(this[item[keyProp]]);
            // @ts-ignore
            this[item[keyProp]].push(finalValue);
          }
        } else {
          this[item[keyProp]] = finalValue;
        }
      }
      return;
    }

    if (value && typeof value === 'object') {
      if (valueFn !== undefined && valueFn !== null) {
        Object.keys(value).forEach(k => {
          this[k] = valueFn(value[k]);
        });
      } else {
        Object.keys(value).forEach(k => {
          this[k] = value[k];
        });
      }
      return;
    }
  }

  // @ts-ignore
  // computeIfAbsent<K, V>(map: Map<K, V>, key: any, callback): V {
  //   const existingValue = map.get(key);
  //   if (existingValue) {
  //     return existingValue;
  //   }
  //   const value = callback(key);
  //   map.set(key, value);
  //   return value;
  // };
}
